export default __webpack_public_path__ + "static/media/books-2048w.2615690e.avif";